import splitComponentStyles from '../split-components';
import splitImageStyles from './split-carousel';

// JW:2021-07-08 - ADO:4838 - Inline helpers to prevent load order issues
var helpers = {
  addClassToAllElements: function addClassToAllElements (elements, clss, index) {
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add(`${clss}${index}`);
    }
  },
  isInEditMode: function isInEditMode () {
    return document.body.classList.contains('pagemode-edit');
  }
}
var globalSplitCarousels = [];
var lastWindowWidth = setWindowWidth(getWindowWidth());
window.addEventListener("resize", () => {
  let currentWindowWidth = getWindowWidth();
  if ((lastWindowWidth < 960 && currentWindowWidth > 959) || (lastWindowWidth > 959 && currentWindowWidth < 960)) {
    createSplitCarousels(); setWindowWidth(currentWindowWidth)
  }
});
createSplitCarousels();
function getWindowWidth() { return window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth }
function setWindowWidth(windowWidth) { lastWindowWidth = windowWidth }
function createSplitCarousels() {
  const splitCarousels = document.querySelectorAll('.split-carousel.swiper-container');
  let currentSlideIndexes = [];globalSplitCarousels.map((carousel) => { currentSlideIndexes.push(carousel.activeIndex); carousel.destroy(!0, !0) });[...splitCarousels].map((splitCarousel, index) => {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
    let autoHite = !1; let initialSlide = 0; if (getWindowWidth() < 960) {
      autoHite = !0
    }
    if (currentSlideIndexes[index]) {
      initialSlide = currentSlideIndexes[index]
    }
    globalSplitCarousels[index] = setCarousel(splitCarousel, index, autoHite, initialSlide)
  })
}
function addUniqueClassToSwiperNavElements(splitCarousel, index) {
  helpers.addClassToAllElements(splitCarousel.querySelectorAll('.split-carousel__swiper-pagination'), 'split-carousel__swiper-pagination', index); helpers.addClassToAllElements(splitCarousel.querySelectorAll('.split-carousel__swiper-button-next'), 'split-carousel__swiper-button-next', index); helpers.addClassToAllElements(splitCarousel.querySelectorAll('.split-carouesel__swiper-button-prev'), 'split-carouesel__swiper-button-prev', index)
}
function setCarousel(splitCarousel, index, autoHite = !1, initialSlide = 0) {
  addUniqueClassToSwiperNavElements(splitCarousel, index);
  let slidesNumber = parseInt(splitCarousel.getAttribute('data-slide-num'));
  return new Swiper(splitCarousel, {
    initialSlide: initialSlide, autoHeight: autoHite, slidesPerView: slidesNumber, effect: 'fade', spaceBetween: 16, loop: !1, allowTouchMove: !helpers.isInEditMode(), pagination: { el: '.split-carousel__swiper-pagination' + index, type: 'custom', renderCustom: function (swiper, current, total) { return `<div class="split-carousel__fraction"><span>${current}</span> / <span>${total}</span></div>` } }, navigation: { nextEl: '.split-carousel__swiper-button-next' + index, prevEl: '.split-carouesel__swiper-button-prev' + index }, breakpoints: { 959: { slidesPerView: 1 } },
  })
}
